import { AbstractPreset, config } from "./AbstractPreset";

export default class RectangleRectangleCustom extends AbstractPreset {
	getName(): string {
		return 'rectangleRectangleCustom';
	}

	getConfig(): config {
		return {
			"base": {
				"shape": "rectangle",
				"presetShape": this.getName(),
				"primitives": {
					"width": 50,
					"length": 50
				},
			},
			"drillholes": {
				"type": "custom",
				"settings": [
					{
						"x": 300,
						"y": 300,
						"diameter": 20
					},
					{
						"x": 350,
						"y": 150,
						"diameter": 20
					},
					{
						"x": 400,
						"y": 350,
						"diameter": 20
					}
				]
			},
			"cutouts": [
				{
					"type": "shape",
					"shape": "rectangle",
					"primitives": {
						"width": 25,
						"length": 15
					},
					"modifiers": [],
					"position": {
						"left": 150,
						"bottom": 250,
						"rotation": 0
					}
				}
			],
		};
	}
}
